<div class="content-box_module__333d9 content-box_lg__3v3a-">
  <header _ngcontent-bps-c143="" class="content-box_header__xPnGx clearfix">
    <div _ngcontent-bps-c143="" class="wil-float-left">
      <h4 _ngcontent-bps-c143="" class="content-box_title__1gBHS">
        <span _ngcontent-bps-c143="">Applied Jobs</span>
      </h4>
    </div>
  </header>

  <div class="content-box_body__3tSRB">
    <div class="jobsearch-typo-wrap jobsearch-applied-jobs">
      <ul>
        <li *ngFor="let job of internalJobs">
          <div class="jobsearch-applied-jobs-wrap">
            <a class="jobsearch-applied-jobs-thumb" [routerLink]="['/jobs/details/', job.slug]"><img
                [src]="getUserProfilePicture(job)" alt=""></a>

            <div class="jobsearch-applied-jobs-text">
              <div class="jobsearch-applied-jobs-left">
                <a [routerLink]="['/user-details/', job.employer_username]"><span>@ {{job.employer_display_name}}</span></a>
                <h2 class="jobsearch-pst-title"><a [routerLink]="['/jobs/details/', job.slug]">{{job.job_title}}</a></h2>

                <ul>
                  <li><i class="jobsearch-icon jobsearch-filter-tool-black-shape"></i> <a
                      [innerHTML]="job.job_sector"></a></li>
                  <li><i class="jobsearch-icon jobsearch-calendar"></i> {{job.applied_at | date:"MMMM d, yyyy"}}</li>
                </ul>
              </div>

              <a [routerLink]="['/jobs/details/', job.slug]" class="jobsearch-savedjobs-links"><i
                  class="jobsearch-icon jobsearch-view"></i></a>
            </div>
          </div>
        </li>
      </ul>
    </div>
  </div>
</div>


<div class="content-box_module__333d9 content-box_lg__3v3a-">
  <header _ngcontent-bps-c143="" class="content-box_header__xPnGx clearfix">
    <div _ngcontent-bps-c143="" class="wil-float-left">
      <h4 _ngcontent-bps-c143="" class="content-box_title__1gBHS">
        <span _ngcontent-bps-c143="">Applied Jobs by Email</span>
      </h4>
    </div>
  </header>

  <div class="content-box_body__3tSRB" *ngIf="emailJobs.length > 0">
    <div class="jobsearch-typo-wrap jobsearch-applied-jobs">
      <ul>
        <li *ngFor="let job of emailJobs">
          <div class="jobsearch-applied-jobs-wrap">
            <a class="jobsearch-applied-jobs-thumb" [routerLink]="['/jobs/details/', job.slug]"><img
                [src]="getUserProfilePicture(job)" alt=""></a>

            <div class="jobsearch-applied-jobs-text">
              <div class="jobsearch-applied-jobs-left">
                <a [routerLink]="['/user-details/', job.employer_username]"><span>@ {{job.employer_display_name}}</span></a>
                <h2 class="jobsearch-pst-title"><a [routerLink]="['/jobs/details/', job.slug]">{{job.job_title}}</a></h2>

                <ul>
                  <li><i class="jobsearch-icon jobsearch-filter-tool-black-shape"></i> <a
                      [innerHTML]="job.job_sector"></a></li>
                  <li><i class="jobsearch-icon jobsearch-calendar"></i> {{job.applied_at | date:"MMMM d, yyyy"}}</li>
                </ul>
              </div>

              <a [routerLink]="['/jobs/details/', job.slug]" class="jobsearch-savedjobs-links"><i
                  class="jobsearch-icon jobsearch-view"></i></a>
            </div>
          </div>
        </li>
      </ul>
    </div>
  </div>
</div>
